import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon } from 'lucide-react';
import { Heading, Section } from './Primitives';
const results = [{
  food: 'Grapes',
  verdict: '🔴 Toxic',
  verdictClass: 'bg-coral/12 text-coral',
  cardClass: 'border-coral/30'
}, {
  food: 'Blueberries',
  verdict: '🟢 Safe',
  verdictClass: 'bg-safe/12 text-safe',
  cardClass: 'border-safe/30'
}];
export function SafeFoods() {
  return <Section className="bg-cream" ariaLabel="Safe Foods Checker" data-id="element-199" data-mp="1zyhimftwib4s">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.45,
      ease: 'easeOut'
    }} className="mx-auto flex max-w-4xl flex-col items-center gap-8 rounded-3xl border border-orangey-100 bg-white px-6 py-8 shadow-soft sm:px-9 lg:flex-row lg:gap-10" data-id="element-200" data-mp="1uylhqpgi2ztg">
        <div className="flex-1 text-center lg:text-left" data-id="element-201" data-mp="1c7u0l1q9u54i">
          <Heading size="md" data-id="element-202" data-mp="1c7c6aan660z8">“Can my dog eat that?” Answered in one search.</Heading>
          <p className="mt-3 leading-relaxed text-ink-500" data-id="element-203" data-mp="36i9obystpcf4">
            Search any food and get the real answer — safe or not, why, how much, and safer alternatives if it's a no.
          </p>
        </div>

        <div className="w-full max-w-xs shrink-0" data-id="element-204" data-mp="3gafh3aqwfxvd">
          <div className="flex items-center gap-2.5 rounded-xl border border-orangey-100 bg-cream px-3.5 py-2.5" data-id="element-205" data-mp="3l87hkt5m0sb6">
            <SearchIcon className="h-4 w-4 text-ink-400" aria-hidden="true" data-id="element-206" data-mp="2nkyrslyksx3d" />
            <span className="text-sm font-semibold text-ink-400" data-id="element-207" data-mp="2sjjvwwgy80x3">Search any food…</span>
          </div>
          <ul className="mt-3 space-y-2.5" data-id="element-208" data-mp="2ximrlqb1guse">
            {results.map(result => <li key={result.food} className={`flex items-center justify-between gap-3 rounded-xl border bg-white px-4 py-3 ${result.cardClass}`} data-id="element-209" data-mp="2xkze8grqrtbs">
                <span className="font-display text-base font-bold text-ink-900" data-id="element-210" data-mp="cuqimqd4jp6n">{result.food}</span>
                <span className={`shrink-0 rounded-xl px-2.5 py-1 font-mono text-[0.62rem] font-semibold uppercase tracking-[0.1em] ${result.verdictClass}`} data-id="element-211" data-mp="htbkeu80ygx7">
                  {result.verdict}
                </span>
              </li>)}
          </ul>
        </div>
      </motion.div>
    </Section>;
}